import React from 'react'
import BaseIcon from 'react-icon-base'
import Phrase from './Phrase'
import { isMobile } from 'react-device-detect'
import { withTranslation } from 'react-i18next'

import { getDimensions } from 'helpers/multibrowserHelper.js'

import './styles.scss'

const bc = 'global-loader'

const GlobalLoader = ({ t }) => {
  console.log('__GlobalLoader__')
  const { width } = getDimensions()
  const widthSize = width > 500 ? 500 : width
  const phrases = [
    'Shuffling MicroActions',
    'Revving up the personal growth engine',
    'Giving you a chance to practice some mindfulness',
    'Clearing out bad habits',
    'Scanning the latest research',
    'Updating habits',
    'Loading your best self',
    'Initiating goal achievement',
    'Breaking barriers to personal growth',
  ]

  return (
    <div className={`${bc}__box`}>
      <BaseIcon width={`${widthSize}px`} height="150px" style={{ marginLeft: isMobile ? '16px' : '0' }}>
        <defs>
          <mask id="mask" maskUnits="userSpaceOnUse" maskContentUnits="userSpaceOnUse">
            <linearGradient id="linearGradient" gradientUnits="objectBoundingBox" x2="0" y2="1">
              <stop stopColor="white" stopOpacity="0" offset="0%" />
              <stop stopColor="white" stopOpacity="1" offset="30%" />
              <stop stopColor="white" stopOpacity="1" offset="70%" />
              <stop stopColor="white" stopOpacity="0" offset="100%" />
            </linearGradient>
            <rect width="100%" height="100%" fill="url(#linearGradient)" />
          </mask>
        </defs>
        <g width="100%" height="100%" mask="url(#mask)">
          <g className={`${bc}__phrases`}>
            {phrases.map((phrase, i) => (
              <Phrase text={t(phrase)} yOffset={30 + 50 * i} key={i} i={i} />
            ))}
          </g>
        </g>
      </BaseIcon>
    </div>
  )
}

export default withTranslation()(GlobalLoader)
